import security from 'stores/security';
import { EditTypeEnum, ProcessStatusEnum, UpdateInfoItem } from './types';

export const getUpdateInfoList = (isSSN: boolean, hasDeliveryAddress: boolean): UpdateInfoItem[] => {
    const finalHasAddress = isSSN || hasDeliveryAddress;
    // [IRA 账户这里展示有特殊逻辑 @taihaoran](https://tigertech.feishu.cn/docx/UpoAdQdtkoRSKKxk1UccbkilnEf#share-VQNgdT9qvo81dCxcau1cL8nxnxc)
    // 当客户开通 individual 和 ira 账户的时候，ira 账户只展示受益人信息
    // 当客户开通 ira 没开通 individual 的时候，第一个开通的 ira 保留所有修改项，剩下的只保留受益人信息
    // 已开户或已入金的账户列表
    const openedAccountList =
        security.switchAccountList?.filter(account => ['OPENED', 'FUNDED'].includes(account.status)) || [];
    /** 仅有 IRA 类型的账户 */
    const onlyIRA = !!openedAccountList?.every(account => account.category === 'IRA');
    /** 当前登录账户是否是 IRA 账户 */
    const isIRA = security.currentAccount?.category === 'IRA';
    /** 当前账户是否是第一个 IRA 账户 */
    const isFirstIRA =
        security.currentAccount?.customerId ===
        openedAccountList.find(account => account.category === 'IRA')?.customerId;
    const beneficiaryItem = {
        eventName: '受益人信息修改',
        path: 'beneficiary',
        title: __('受益人信息'),
        type: EditTypeEnum.BENEFICIARY
    };

    let list: UpdateInfoItem[] = [
        {
            title: __('个人信息'),
            type: EditTypeEnum.CERTIFICATE,
            path: 'baseinfo',
            eventName: '个人信息修改'
        },
        // 非SSN三期address路由可以修改居住地址或邮寄地址 https://tigertech.feishu.cn/wiki/CPzBwLSswi6kP4kGHoFczcuFnnf
        finalHasAddress
            ? {
                  title: __('居住地址/邮寄地址'),
                  type: EditTypeEnum.ADDRESS,
                  path: 'address',
                  eventName: '居住地址/邮寄地址信息修改'
              }
            : undefined,
        {
            title: __('职业状态'),
            type: EditTypeEnum.WORK_PROFILE,
            path: 'job',
            eventName: '职业状态信息修改'
        },
        {
            title: __('客户资格问卷'),
            type: EditTypeEnum.QUESTIONNAIRE,
            path: 'questionnaire',
            eventName: '客户资格问卷信息修改'
        },
        {
            title: __('规管信息'),
            type: EditTypeEnum.REGULATORY_INFO,
            path: 'regulatoryInfo',
            eventName: '规管信息修改'
        },
        {
            title: __('资产和收入'),
            type: EditTypeEnum.ASSETS,
            path: 'assets',
            eventName: '资产和收入信息修改'
        },
        {
            title: __('投资目标'),
            type: EditTypeEnum.INVEST_TARGET,
            path: 'invest',
            eventName: '投资目标信息修改'
        }
    ].filter(Boolean) as UpdateInfoItem[];

    if (onlyIRA && isFirstIRA) {
        list.push(beneficiaryItem);
    } else if (isIRA) {
        list = [beneficiaryItem];
    }

    return list;
};

export const statusConfig: Record<ProcessStatusEnum, { statusText: string; color: string }> = {
    [ProcessStatusEnum.PENDING]: {
        statusText: __('审核中'),
        color: 'orange'
    },
    [ProcessStatusEnum.SUCCESS]: {
        statusText: __('重新提交'),
        color: 'green'
    },
    [ProcessStatusEnum.REJECTED]: {
        statusText: __('重新提交'),
        color: 'red'
    },
    [ProcessStatusEnum.INVALID]: {
        statusText: __('重新提交'),
        color: 'red'
    }
};
